
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";

export interface BtnProps {
    to?: ReactRouterDom.To;
    href?: string;
    icon?: string;
    target?: string;
    disabled?: boolean;
    size?: "sm" | "md";
    children: React.ReactNode;
    variant?: "primary" | "light" | "outline";
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

// the label is rendered twice so it can roll up on hover, like the reference buttons
function Btn({ children, variant = "primary", size = "md", icon = "fa fa-arrow-right", to, href, target, disabled, onClick }: BtnProps) {

    const className = Classname.build(styles["btn"], styles[`btn-${variant}`], styles[`btn-${size}`]);
    const content = (<>
        <span className={styles["btn-icon"]}><i className={icon} /></span>
        <span className={styles["btn-text"]}>
            <span>{children}</span>
            <span aria-hidden>{children}</span>
        </span>
    </>);

    if (to) {
        return (<ReactRouterDom.NavLink end to={to} target={target} className={className} onClick={onClick}>{content}</ReactRouterDom.NavLink>);
    }
    if (href) {
        return (<a href={href} target={target} rel={target === "_blank" ? "noreferrer" : undefined} className={className} onClick={onClick}>{content}</a>);
    }
    return (<button className={className} disabled={disabled} onClick={onClick}>{content}</button>);
}

export default Btn;
